export default __webpack_public_path__ + "static/media/stop.74a7759c.png";